<script>
import { endEvent } from '~/queries/eventControls.gql'
import PostEventModal from '~/components/modals/PostEventModal.vue'

export default {
  computed: {
    liveEvent () {
      const user = this.$store.state.user
      if (user?.events?.length < 1) { return false }

      // find first event where shortcode is not null to ignore spectator events
      return user?.events?.find(event => event.shortcode)
    },
    lastClosedEvent () {
      return this.$store.state.lastClosedEvent
    }
  },
  methods: {
    startEndEvent (eventId) {
      this.$buefy.dialog.confirm({
        // title: 'End this event?',
        message: '<p class="m-t-10"><b>Are you sure you want to end this event?</b></p>',
        cancelText: 'Cancel',
        class: 'delete-deck',
        confirmText: `End Event`,
        onConfirm: () => {
          this.endEvent(eventId)
        }
      })
    },
    async endEvent (eventId) {
      const { data: { update_events_by_pk: event } } = await this.$apollo.mutate({
        mutation: endEvent,
        variables: {
          eventId
        }
      })

      const players = event.participants_aggregate.aggregate.count
      const responses = event.responses_aggregate.aggregate.count
      const settings = event.settings

      this.log('ending event. Settings:', settings)

      if (settings.spectatorEventId && settings.isMainEvent) {
        this.endSpectatorEvent(settings.spectatorEventId)
      }

      this.posthogCapture('event:end', {
        event_id: eventId,
        shortcode: event.shortcode,
        deck_id: event.slideDeck,
        num_players: players,
        num_responses: responses
      })

      this.log(`event ended with players: ${players}, responses: ${responses}`)

      await this.sendEventRecapEmails(eventId)

      if (players > 4 || (players > 1 && responses > 8)) {
        this.log('real event ended, opening rating model')
        this.openPostEventModal(eventId)
      }
    },
    async endSpectatorEvent (eventId) {
      this.log('ending spectator event')
      await this.$apollo.mutate({
        mutation: endEvent,
        variables: {
          eventId
        }
      })
    },
    /*
    ** sendEventRecapEmails Function is duplicated in SlideFrame.vue
    */
    async sendEventRecapEmails (eventId) {
      this.log('sending recap emails to players for event ' + eventId)

      try {
        const resp = await this.$axios.post(process.env.SITE_URL + '/api/send-recap-emails', { eventId })
        this.log('recap email response:', resp)
      } catch (e) {
        console.error('Error sending event recap emails:', e)
      }
    },
    openPostEventModal (eventId) {
      this.$buefy.modal.open({
        parent: this,
        component: PostEventModal,
        customClass: 'post-event-modal',
        width: 600,
        trapFocus: true,
        onCancel: () => {
          this.log('cancelling post event modal')
          this.$store.commit('setLastClosedEvent', {})
        },
        events: {
          close: () => {
            this.log('closing post event modal')
            this.$store.commit('setLastClosedEvent', {})
          }
        },
        props: {
          eventId
        }
      })
    },
    checkPostEventModal () {
      this.log('checking if we should open post event modal')
      const lastEvent = this.lastClosedEvent
      if (!lastEvent.eventId) {
        this.log('no last event found')
        return
      }

      if (lastEvent.players > 4 || (lastEvent.players > 1 && lastEvent.responses > 8)) {
        this.log('real event ended, opening rating model')
        this.openPostEventModal(lastEvent.eventId)
        return
      }

      this.log('last event found but not enough players or responses')
    }
  }
}
</script>
